function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#f0f0f0",
  d: "M0 85.331h512v341.337H0z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M0 85.331h512v48.762H0zm0 97.525h512v48.762H0zm0 97.525h512v48.762H0zm0 97.514h512v48.762H0z",
  fill: "#6da544"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#d80027",
  d: "M0 85.331h256v146.287H0z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M116.87 199.777l-7.421-14.84v-29.682L128 140.415l18.551 14.84v22.261l7.42-7.42v14.841l-14.841 14.84zm-39.911-45.511l1.965 6.047h6.357l-5.143 3.736 1.966 6.047-5.145-3.737-5.143 3.737 1.964-6.047-5.142-3.736h6.357zM91.8 139.425l1.965 6.048h6.358l-5.144 3.736 1.965 6.046-5.144-3.736-5.143 3.736 1.965-6.046-5.144-3.736h6.358zm14.841-14.841l1.964 6.047h6.358l-5.143 3.738 1.964 6.046-5.143-3.737-5.144 3.737 1.965-6.046-5.144-3.738h6.358zm72.4 29.682l-1.965 6.047h-6.357l5.143 3.736-1.966 6.047 5.145-3.737 5.143 3.737-1.964-6.047 5.142-3.736h-6.357zm-14.842-14.841l-1.964 6.048h-6.357l5.143 3.736-1.965 6.046 5.143-3.736 5.145 3.736-1.966-6.046 5.144-3.736h-6.358zm-14.84-14.841l-1.964 6.047h-6.358l5.143 3.738-1.964 6.046 5.143-3.737 5.144 3.737-1.965-6.046 5.144-3.738h-6.358zM128 117.164l-1.965 6.048h-6.357l5.143 3.736-1.964 6.046 5.143-3.736 5.143 3.736-1.964-6.046 5.143-3.736h-6.356z",
  fill: "#f0f0f0"
});

const SvgAbkhazia = (_ref) => {
  let svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAbkhazia, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/abkhazia.c66e950d.svg";
export { ForwardRef as ReactComponent };